import { createModal } from '/@/core/elements/modal'

export interface EditProjectProductModalData {
  projectProductId: string
}

const { api, component } = createModal<EditProjectProductModalData>(
  'EditProjectProductModal',
  () => import('./EditProjectProductModal.vue'),
  {
    projectProductId: '',
  },
)

export const useEditProjectProductModal = api
export default component
